import dayjs from 'dayjs'
import {arrayOfDatesToString} from '@/shared/DateHelper'

export const updateSocialMedia = function(externalEntity, socialMediaFormValues) {
    let hasSocialMediaValues = false
    let areSocialMediaDirty = false
    Object.keys(socialMediaFormValues).forEach((key) => {
        if(socialMediaFormValues[key]) {
            hasSocialMediaValues = true
        }
    })

    if (externalEntity.social_media) {
        if (hasSocialMediaValues) {
            Object.keys(socialMediaFormValues).forEach((key) => {
                let isMatch = false
                for (let i = 0; i < externalEntity.social_media.length; ++i) {
                    if (externalEntity.social_media[i].name && key == externalEntity.social_media[i].name) {
                        isMatch = true
                        if (externalEntity.social_media[i].relationship_url != socialMediaFormValues[key]) {
                            areSocialMediaDirty = true
                        }
                    }
                }
                if(socialMediaFormValues[key] && false == isMatch) {
                    areSocialMediaDirty = true
                }
            })
        } else {
            delete externalEntity.social_media
            areSocialMediaDirty = true
        }

        if (areSocialMediaDirty) {
            externalEntity.social_media = []
            Object.keys(socialMediaFormValues).forEach((key) => {
                if(socialMediaFormValues[key]) {
                    const name = 'Twitter' == key ? 'X' : key
                    externalEntity.social_media.push({name: name, relationship_url: socialMediaFormValues[key]})
                }
            })
        }
    } else {
        const social_media = []
        Object.keys(socialMediaFormValues).forEach((key) => {
            if(socialMediaFormValues[key]) {
                areSocialMediaDirty = true
                const name = 'Twitter' == key ? 'X' : key
                social_media.push({name: name, relationship_url: socialMediaFormValues[key]})
            }
        })

        if (areSocialMediaDirty) {
            externalEntity.social_media = social_media
        }
    }

    return areSocialMediaDirty
}

export const attendeesSortByName = function(attendees) {
    attendees.forEach((attendee) => {
        if (attendee.family_name) {
            attendee.sortName = attendee.family_name + ' ' + attendee.given_name
        } else {
            attendee.sortName = 'zz' + attendee.display_name // push these to the end
        }
    })

    attendees.sort((first, second) => {
        return second.sortName > first.sortName ? -1 : 1
    })
}

export const checkForSessionInvitation = function(sessions, attendeeId = null) {
    for (let i = 0; i < sessions.length; ++i) {
        if (sessions[i].invitation_only) {
            let invited = false;
            if (null != attendeeId) {
                for (let j = 0; j < sessions[i].invited_attendees.length; ++j) {
                    if (attendeeId == sessions[i].invited_attendees[j].id) {
                        invited = true
                        break
                    }
                }
            }
            // If this attendee isn't on the guest list for this session, filter this session from the array
            if (false == invited) {
                sessions = sessions.filter((session) => session !== sessions[i])
            }
        }
    }

    return sessions
}

export const dollarAmountToString = function(amount) {
    let amountString = amount.toLocaleString('en-US', {style: 'currency', currency: 'USD',})
    if ('$' != amountString.substring(0, 1)) { // apparently different browsers implement this differently
        amountString = '$' + amountString
    }
    return amountString
}

export const getCookieValue = function(cookieName) {
    return document.cookie.split('; ').find((row) => row.startsWith(cookieName + '='))?.split('=')[1]
}

export const prepareEventsList = function(data, isStaff, sortDescending = false) {
    const sortFormer = sortDescending ? 1 : -1
    const sortLatter = sortDescending ? -1 : 1
    let events = data
    setStartAndEndDates(events)
    setDateStrings(events)
    events = events.sort((event1, event2) => {
        return event1.start_date < event2.start_date ? sortFormer : sortLatter
    })
    if (false == isStaff) {
        events = getPublishedEvents(events)
    }

    return events
}

// Assumes that the sessions array is sorted by calendar_date and start_time
export const sessionsGroupByTimeslots = function(sessions) {
    let previousSession = {timeslot: {start_time: '', end_time: '', date: {calendar_date: ''}}}
    for (let i = 0; i < sessions.length; ++i) {
        let timeslotLabel = ''
        if (sessions[i].timeslot.date.calendar_date != previousSession.timeslot.date.calendar_date) {
            timeslotLabel = makeTimeslotLabel(sessions[i])
        } else {
            if (sessions[i].timeslot.start_time != previousSession.timeslot.start_time
                || sessions[i].timeslot.end_time != previousSession.timeslot.end_time) {
                timeslotLabel = makeTimeslotLabel(sessions[i])
            }
        }
        if (0 < i) {
            sessions[i - 1].isEndOfTimeslot = (timeslotLabel != '')
        }
        sessions[i].timeslotLabel = timeslotLabel
        previousSession = sessions[i]
    }
    if (0 < sessions.length) {
        sessions[sessions.length - 1].isEndOfTimeslot = false
    }

    return sessions
}

export const sessionsMarkScheduleConflicts = function(sessions) {
    for (let i = 0; i < sessions.length; ++i) {
        const overlappingSessions = new Array()
        for (let j = 0; j < sessions.length; ++j) {
            if( i == j){
                continue // we can't conflict with ourselves
            }
            if(sessions[i].attending && sessions[j].attending){
                if (false == sessions[i].does_not_conflict && false == sessions[j].does_not_conflict &&
                    timeslotsOverlap(sessions[i], sessions[j])) {
                    overlappingSessions.push(sessions[j])
                }
            }
        }
        sessions[i].conflictingSessions = overlappingSessions
    }
    return sessions
}

export const sessionsSortByDateAndTime = function(sessions) {
    return sessions.sort((session1, session2) => {
        if (session1.timeslot && session2.timeslot) {
            if( (session1.timeslot.start_time == session2.timeslot.start_time) &&
                (session1.timeslot.date.calendar_date == session2.timeslot.date.calendar_date)){
                // if we have matching start times (and dates) we sort by session.order
                if(session1.order < session2.order){
                    return -1
                }
                if(session1.order > session2.order){
                    return 1
                }
            }
            if (session1.timeslot.date.calendar_date < session2.timeslot.date.calendar_date) {
                return -1
            }
            if (session1.timeslot.date.calendar_date > session2.timeslot.date.calendar_date) {
                return 1
            }
            return session1.timeslot.start_time < session2.timeslot.start_time ? -1 : 1
        }
        if (null == session1.timeslot) {
            return -1
        }
        return 1
    })
}

export const sessionsSortByEvents = function(sessions) {
    let eventArrays = []
    for (let i = 0; i < sessions.length; ++i) {
        let j = 0;
        while (eventArrays[j] && eventArrays[j].event.name != sessions[i].event.name) {
            ++j
        }
        if (j == eventArrays.length) {
            eventArrays.push({event: {id: sessions[i].event.id, name: sessions[i].event.name}, sessions: []})
        }
        eventArrays[j].sessions.push(sessions[i])
    }

    for (let i = 0; i < eventArrays.length; ++i) {
        let startDate = eventArrays[i].sessions[0].timeslot.date.calendar_date
        for (let j = 1; j < eventArrays[i].sessions.length; ++j) {
            if (eventArrays[i].sessions[j].timeslot.date.calendar_date < startDate) {
                startDate = eventArrays[i].sessions[j].timeslot.date.calendar_date
            }
        }
        eventArrays[i].event.startDate = startDate
    }

    eventArrays = eventArrays.sort((eventArray1, eventArray2) => {
        return eventArray1.event.startDate <= eventArray2.event.startDate ? -1 : 1
    })

    return eventArrays
}

export const sessionsSortWithinTimeslots = function(sessions) {
    let i = 0;
    let sortedSessions = []
    while (i < sessions.length) {
        // Break off a piece of the array with those sessions in the next timeslot
        let sessionsInTimeslot = []
        const timeslotId = sessions[i].timeslot.id
        while (i < sessions.length && timeslotId == sessions[i].timeslot.id) {
            sessionsInTimeslot.push(sessions[i])
            ++i
        }

        // Check if there's explicit ordering
        let orderBySessionTitle = true
        const firstOrderValue = sessionsInTimeslot[0].order
        for (let j = 1; j < sessionsInTimeslot.length; ++j) {
            if (sessionsInTimeslot[j].order != firstOrderValue) {
                orderBySessionTitle = false
                break
            }
        }
        if (orderBySessionTitle) {
            sessionsInTimeslot = sessionsInTimeslot.sort((session1, session2) => {
                return getSessionTitle(session1) <= getSessionTitle(session2) ? -1 : 1
            })
        } else {
            sessionsInTimeslot = sessionsInTimeslot.sort((session1, session2) => {
                return session1.order <= session2.order ? -1 : 1
            })
        }
        
        // Check if the first session in the timeslot got moved down - rearrange formatting if so
        if ('' == sessionsInTimeslot[0].timeslotLabel) {
            let j = 0
            while (j < sessionsInTimeslot.length) {
                if ('' != sessionsInTimeslot[j].timeslotLabel) {
                    sessionsInTimeslot[0].timeslotLabel = sessionsInTimeslot[j].timeslotLabel
                    sessionsInTimeslot[j].timeslotLabel = ''
                    break
                }
                ++j
            }
        }

        // Check if the last session in the timeslot got moved up - change flagging if so
        if (false == sessionsInTimeslot[sessionsInTimeslot.length - 1].isEndOfTimeslot) {
            for (let j = 0; j < sessionsInTimeslot.length - 1; ++j) {
                sessionsInTimeslot[j].isEndOfTimeslot = false
            }
            sessionsInTimeslot[sessionsInTimeslot.length - 1].isEndOfTimeslot = true
        }

        sortedSessions = sortedSessions.concat(sessionsInTimeslot)
    }

    return sortedSessions
}

export const setDateStrings = function(events) {
    for (let i = 0; i < events.length; ++i) {
        events[i].dateString = arrayOfDatesToString(events[i].dates)
    }
}

export const setStartAndEndDates = function(events) {
    for (let i = 0; i < events.length; ++i) {
        if (events[i].dates[0]) {
            let startDate = events[i].dates[0].calendar_date
            let endDate = events[i].dates[0].calendar_date

            for (let j = 1; j < events[i].dates.length; ++j) {
                if (events[i].dates[j].calendar_date < startDate) {
                    startDate = events[i].dates[j].calendar_date
                }

                if (events[i].dates[j].calendar_date > endDate) {
                    endDate = events[i].dates[j].calendar_date
                }
            }

            events[i].start_date = startDate
            events[i].end_date = endDate
        } else {
            events[i].start_date = events[i].end_date = ''
        }
    }
}

export const telephoneNumberFormat = function(phoneNumber, clickable = true) {
    let telephoneNumber = phoneNumber.replace(/\D/g, '')
    if (telephoneNumber) {
         if ('1' == telephoneNumber.substring(0, 1)) {
            telephoneNumber = telephoneNumber.substring(1)
        }

        if (10 == telephoneNumber.length) {
            telephoneNumber = telephoneNumber.substring(0, 3) + '-'
                + telephoneNumber.substring(3, 6) + '-'
                + telephoneNumber.substring(6)
            if (clickable) {
                telephoneNumber = '<a href="tel:' + telephoneNumber + '">' + telephoneNumber + '</a>'
            }
        }
    }

    return telephoneNumber
}

export const presentersSortByEvents = function (presenters = null) {
    if (presenters) {
        if (presenters.length > 1) {
            presenters.forEach((presenter) => {
                setStartAndEndDates(presenter.events)
            })
            presenters.sort((eventArray1, eventArray2) => {
                const date1 = dayjs(eventArray1.events[0].start_date)
                const date2 = dayjs(eventArray2.events[0].start_date)
                return date1.diff(date2) <= 0 ? -1 : 1
            })
        }
    }
}

function getSessionTitle(session) {
    let sessionTitle = session.name
    if (session.code) {
        sessionTitle = session.code + ' ' + sessionTitle
    }

    return sessionTitle
}

function getPublishedEvents(events) {
    let publishedOnly = events.filter(
        function(item) {
            return item.is_published == true;
        }
    )

    return publishedOnly
}

function makeTimeslotLabel(session) {
    const dummyDate = '1971-01-01 '
    const startTime = dayjs(dummyDate + session.timeslot.start_time).format('h:mm A')
    const endTime = dayjs(dummyDate + session.timeslot.end_time).format('h:mm A')
    return startTime + ' -<br />' + endTime
}

function overlaps(timeslot1, timeslot2) {
    return (timeslot1.start_time < timeslot2.start_time && timeslot1.end_time > timeslot2.start_time)
}

// exported only to expose to unit testing
export const timeslotsOverlap = function(session1, session2) {
    const timeslot1 = session1.timeslot
    const timeslot2 = session2.timeslot
    if (timeslot1.date.calendar_date == timeslot2.date.calendar_date) {
        return timeslot1.start_time == timeslot2.start_time ||
            timeslot1.end_time == timeslot2.end_time ||
            overlaps(timeslot1, timeslot2) ||
            overlaps(timeslot2, timeslot1)
    }
    return false
}

